import { render, staticRenderFns } from "./IcoPerson.vue?vue&type=template&id=3bf55606"
import script from "./IcoPerson.vue?vue&type=script&lang=js"
export * from "./IcoPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports